import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { selectCartEvent } from '../selectors';

const Seats = ({ userSeats, open }) => {
    const event = useSelector(selectCartEvent);
    return (
        <>
            <Accordion defaultActiveKey={open ? '0' : null}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <span className="d-block mb-3 w-100">
                            <span className="h4"><FormattedMessage id="cart_your_seats"/></span>
                            <a className="btn-change-seats ms-2 text-muted text-decoration-none" href={event.slug}>
                                <i className="bi bi-pencil-square me-1"/><FormattedMessage id="change"/></a>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        {userSeats.map((userSeat, index) => (
                            <div key={index} className="mb-3">
                                {userSeat.tickets.map((ticket, ticketIndex) => (
                                    <div className="tickets-section" key={ticketIndex}>
                                        <p className="mb-1"><strong>{ticket.noOfTickets} x {ticket.name}</strong></p>
                                        {ticket.seatTogether && (
                                            <p className="mb-1">
                                                <span className="bi bi-seated-together me-2"></span>
                                                <FormattedMessage id="cart_seated_together"/>
                                            </p>)}
                                        {ticket.seats.map((seat, seatIndex) => (
                                            <span className="text-muted" key={seatIndex}>{seat}<br/></span>
                                        ))}
                                    </div>
                                ))}
                                <div className="d-flex">
                                    <div className="seller-icon me-3">
                                        <div className="seller-avatar text-dark-emphasis rounded-circle fs-2">
                                            <i className="bi bi-person-fill"></i>
                                        </div>
                                        <div className="seller-verified"></div>
                                    </div>
                                    <div className="seller-account">
                                        <FormattedMessage id="sold_by"/> {userSeat.soldBy}<br/>
                                        <small className="text-muted">{userSeat.countSoldTickets} <FormattedMessage
                                            id="tickets_sold"/></small>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};
export default Seats;
